document.addEventListener('DOMContentLoaded', () => {
    if ($(window).width() > 1101) {
      $(window).scroll(function () {
        if ($(window).scrollTop() + ($(window).height() * 2) / 3 > $('.images-style1').offset().top) {
          $('.images-style1').addClass('animate-text');
        } else {
          $('.images-style1').removeClass('animate-text');
        }
      });
    }
  });